import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react'
import pop_close from '@/assets/images/modal/pop-close.svg'

import './index.less'

let popup: any = null
const Popup = forwardRef((props: any, ref: any) => {
  const { popupData } = props

  const [objData, setObjData] = useState<any>({})
  useImperativeHandle(ref, () => ({
    handleSetStyle,
  }))
  useEffect(() => {
    popup = document.getElementById('rural-popup')
    setObjData(popupData)
    showPopup()
  }, [popupData])

  const handleSetStyle = (data: any) => {
    popup.style.left = `${data.sx}px`
    popup.style.top = `${data.sy}px`
  }

  const showPopup = () => {
    if (popup) {
      popup.style.display = 'block'
    }
  }

  const hidePopup = () => {
    if (popup) {
      popup.style.display = 'none'
    }
  }

  const openDetailPage = () => {
    if (props.clickCallback && typeof props.clickCallback === 'function') {
      props.clickCallback(objData)
    }
  }
  return <div>
      <div
          id="rural-popup"
          style={{
            display: 'block',
            top: objData ? objData.sy : 0,
            left: objData ? objData.sx : 0,
          }}
        >
          <div className="head">
            <div className="title"> 사업명(사업년도)</div>
            {/* <button onClick={hidePopup} className="close"></button> */}
            <img className="close" onClick={hidePopup} src={pop_close} alt="close" />
          </div>
          <div className="body">
            {objData && (
              <div onClick={openDetailPage} className="title">
                {' '}
                {objData.btypNm}({objData.year})
              </div>
            )}
          </div>
        </div>
    </div>
})

export default Popup
